"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCombinations = void 0;
const generateCombinations = (validDays, courseInstances, currentIndex = 0, currentCombination = []) => {
    if (currentIndex === validDays.length) {
        // Base case: all days have been assigned a course
        return [currentCombination];
    }
    const combinations = [];
    const day = validDays[currentIndex];
    for (const course of day.courses) {
        if (course.rate > 0 && courseInstances[course.id] > 0) {
            // Clone courseInstances to avoid mutating the original in recursive calls
            const newCourseInstances = { ...courseInstances };
            newCourseInstances[course.id]--;
            const newCombination = [
                ...currentCombination,
                {
                    date: day.date,
                    course: course.name.en,
                    course_id: course.id,
                    rate: course.rate,
                },
            ];
            // Recurse with the updated courseInstances and combination
            const nextCombinations = (0, exports.generateCombinations)(validDays, newCourseInstances, currentIndex + 1, newCombination);
            // Aggregate the results
            combinations.push(...nextCombinations);
        }
    }
    return combinations;
};
exports.generateCombinations = generateCombinations;
